import { createUploadLink } from 'apollo-upload-client';
import config from '../../config';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () =>
  createUploadLink({
    uri: config.apiUrl,
  });
